import React, { useEffect, useState } from 'react'
import translations from '../../shared/Translations';
import { Link, useNavigate } from 'react-router-dom';
import './index.css'
import { FaLessThanEqual } from 'react-icons/fa';
import AOS from "aos";
import "aos/dist/aos.css";
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { toast } from 'react-toastify';
import CommonPagination from '../../components/pagination';
import gpay from '../../assets/images/gpay-how-to-create-or-find-upi-1200x675.jpg'
import phonepe from '../../assets/images/phonepes.png'

function AddFinance() {

    useEffect(() => {
      AOS.init({
        duration: 1000,
        once: false,
        mirror: true,
      });
    }, []);


  const navigate = useNavigate();
      const [isEditing,setIsEditing] = useState(false)
      const [submit,setSubmit] = useState(false)
const [selectedCustomer, setSelectedCustomer] = useState(null);
const [loading, setLoading] = useState(false)
const [financeDeleteId,setFinanceDeleteId] = useState("")
const [customerName,setCustomerName] = useState("")
  const [currentPage, setCurrentPage] = useState(1);
  // const [recordsPerPage] = useState(10);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
const [pageSizes, setPageSizes] = useState([]);


        const [lang, setLang] = useState("en");
     const t = (key) => translations[lang][key] || key;
    
     useEffect(() => {
        const savedLang = localStorage.getItem("lang");
        if (savedLang) setLang(savedLang);
      }, []);

      
  const handleBackCustomer = () => {
    navigate("/dashboard");
  };

  const [form, setForm] = useState({
  name: "",
  date: "",
  amount: "",
  phoneNumber: "",
  interestRate: "",
  payDuration: "",

  // calculated fields
  intrestamount: "",     
  weeklyInterest: "",   
  totalPayable: "",     
});

const [payModal, setPayModal] = useState(false);
const [selectedItem, setSelectedItem] = useState(null);

const [payForm, setPayForm] = useState({
  principalPay: "",
  interestPay: "",
  payDate: "",
  payMethod: "",
  gpayNumber: "",
  phonePeNumber: "",
  accountNumber: ""
});


const handlePayClick = async (item) => {
  try {
    setLoading(true);

    const response = await superAdminApis.financeGet(item.id);

    if (response?.apiStatus?.code === "200") {
      const data = response.result;

      setSelectedItem(data);

      setPayForm({
        principalPay: data.remaining || "",
        interestPay: data.interest || "",
        payDate: "",
        payMethod: "",
        gpayNumber: "",
        phonePeNumber: "",
        accountNumber: "",
        name:data.name
      });

      setPayModal(true);
    }

  } catch (err) {
    console.error("Pay API error:", err);
  } finally {
    setLoading(false);
  }
};
       const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "phoneNumber") {
    if (!/^\d*$/.test(value)) return; 
    if (value.length > 10) return;
  }

  setForm((prev) => ({
    ...prev,
    [name]: value
  }));
};


const closeClick = () => {
  setForm({
    name: "",
    date: "",
    amount: "",
    rate: "",
    intrestamount: "",
    payMethod: "",
    payDuration: "",
    gpayNumber: "",
    phonePeNumber: "",
    phoneNumber: "",   
    weeklyInterest: "",
    totalPayable: "",
  });
  setSelectedItem(null);
};

const closeClickPay = () =>{
  setSubmit(false)
  setPayForm({
     principalPay: "",
  interestPay: "",
  payDate: "",
  payMethod: "",
  gpayNumber: "",
  phonePeNumber: "",
  accountNumber: ""
  })
  setSelectedItem(null)
}

useEffect(() => {
  const amount = Number(form.amount || 0);
  const rate = Number(form.interestRate || 0);
  const duration = form.payDuration;

  if (!amount || !rate || !duration) return;

  const totalInterest = (amount * rate) / 100;

  let weeklyInterest = 0;
  let totalPayable = 0;

  if (duration === "Weekly") {
    console.log('mmmmmmmmm');
    
    weeklyInterest = totalInterest / 10;
    totalPayable = amount + totalInterest;
  }

  if (duration === "Monthly") {
    weeklyInterest = totalInterest / 4;
    totalPayable = amount + totalInterest;
  }

  setForm((prev) => ({
    ...prev,
    intrestamount: totalInterest.toFixed(2),
    weeklyInterest: weeklyInterest.toFixed(2),
    totalPayable: totalPayable.toFixed(2),
  }));
}, [form.amount, form.interestRate, form.payDuration]);

const calculateFinance = (amount, rate, weeks) => {
  const numericRate = parseFloat(rate);

  const totalInterest = (amount * numericRate) / 100;
  const weeklyInterest = totalInterest / weeks;
  const totalPayable = amount + totalInterest;

  return {
    totalInterest,
    weeklyInterest,
    totalPayable
  };
};

const weeks = 10; 

const [financeList, setFinanceList] = useState([]);


  useEffect(() => {
    handleFinanceList(currentPage)
  }, [currentPage,recordsPerPage]);


  const handleFinanceList = (page) => {
    setLoading(true);

    const apiData = {
      pageIndex: page - 1,
      dataLength: recordsPerPage,
    };

    superAdminApis.financeList(apiData)
      .then((responseData) => {
        if (responseData?.apiStatus?.code === "200") {
          setLoading(false);
          setFinanceList(responseData?.result?.financeDetails || []);
          setTotalRecords(responseData?.result?.totalRecordCount || 0);
const sizes = responseData?.result?.totalSort;

console.log(sizes);


setPageSizes(
  Array.isArray(sizes)
    ? sizes
    : []
);
        } else {
          setFinanceList([]);
          setLoading(false);
          // toast.error(responseData?.apiStatus?.message || "Failed to fetch data");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching customer details:", error);
        toast.error("An error occurred while fetching data.");
      });
  };


   const handleDeleteFinance = () => {
    superAdminApis.financeDeleteAPI(financeDeleteId)
      .then((responseData) => {
        if (responseData.apiStatus.code === '200') {
          const newTotalRecords = totalRecords - 1;
          setTotalRecords(newTotalRecords);
          let totalPages = Math.ceil(newTotalRecords / recordsPerPage);
          if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
          }
          else if (currentPage < 1) {
            setCurrentPage(1);
          }
          const closeButton = document.getElementById("closedeleteModal");
          if (closeButton) {
            handleFinanceList(currentPage);
            closeButton.click();
          }
          toast.success(responseData?.apiStatus?.message);
        } else {
          toast.error(responseData?.apiStatus?.message);
        }
      })
      .catch((error) => {
        setLoading(false)
        console.error("Error during login:", error);
        toast.error("An error occurred during login.");
      });
  };

    const totalPages = Math.ceil(totalRecords / recordsPerPage);

   

const financeCreate = async () => {
  // if (submit) return; 

  const payload = {
    name: form.name,
    date: form.date,
    phone_no: form.phoneNumber,

    loan_amount: Number(form.amount),
    interest_rate: Number(form.interestRate),
    pay_duration: form.payDuration,

    total_interest: Number(form.intrestamount),
    weekly_interest: Number(form.weeklyInterest),
    total_payable: Number(form.totalPayable),
  };

  try {
    setSubmit(true);

    let responseData;

    if (isEditing) {
      payload.id = form.id;
      responseData = await superAdminApis.financeUpdateAPI(payload);
    } else {
      responseData = await superAdminApis.financeCreate(payload);
    }

    if (responseData?.apiStatus?.code === "200") {
      console.log("✅ Success");
 toast.success(responseData?.apiStatus?.message)
      const modal = document.getElementById("addfinance"); // or your modal id
const modalInstance = window.bootstrap.Modal.getInstance(modal);
modalInstance.hide();

      // 🔄 reset form
      setForm({
        id: "",
        name: "",
        date: "",
        phoneNumber: "",
        amount: "",
        interestRate: "",
        payDuration: "",
        intrestamount: "",
        weeklyInterest: "",
        totalPayable: "",
      });

      setIsEditing(false);
handleFinanceList()
   

    } else {
      console.error("❌ API Error:", responseData);
       toast.error(responseData?.apiStatus?.message)
    }

  } catch (error) {
    console.error("❌ Server Error:", error);
  } finally {
    setSubmit(false); 
  }
};

const handleEdit = (item) => {
  setIsEditing(true);

  setForm({
    id: item.id,

    name: item.name || "",
    date: item.date || "",
    phoneNumber: item.phone_no || "",

    amount: Number(item.loan_amount || 0),
    interestRate: Number(item.interest_rate || 0),
    payDuration: item.pay_duration || "",

    intrestamount: Number(item.total_interest || 0),
    weeklyInterest: Number(item.weekly_interest || 0),
    totalPayable: Number(item.total_payable || 0),
  });
};


// const getCurrentDateTime = () => {
//   const now = new Date();

//   // YYYY-MM-DD
//   const date = now.toISOString().split("T")[0];

//   // 12-hour time with AM/PM
//   let hours = now.getHours();
//   const minutes = now.getMinutes().toString().padStart(2, "0");

//   const ampm = hours >= 12 ? "PM" : "AM";

//   hours = hours % 12;
//   hours = hours ? hours : 12; // 0 -> 12

//   const time = `${hours}:${minutes} ${ampm}`;

//   return `${date} ${time}`;
// };


const getCurrentDateTime = () => {
  const now = new Date();

  const date = now.toLocaleDateString("en-CA"); 
  const time = now.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false 
  });

  return `${date} ${time}`;
};

const handlePay = async () => {
  setSubmit(true);

  if (!payForm.payDate) {
    
    return;
  }


//   if (Number(payForm.principalPay) > Number( !selectedItem?.remain_interest_amount ||
//     selectedItem?.remain_interest_amount === "0"
//       ? selectedItem?.total_interest || "0"
//       : selectedItem?.remain_interest_amount)) {
//   toast.error("Principal amount exceeds remaining loan!");
//   return;
// }

  const payload = {
    id: selectedItem.id,

    name: selectedItem.name,
    date: selectedItem.date,
    phone_no: selectedItem.phone_no,

    loan_amount: selectedItem.loan_amount,
    interest_rate: selectedItem.interest_rate,
    pay_duration: selectedItem.pay_duration,

    total_interest: selectedItem.total_interest,
    weekly_interest: selectedItem.weekly_interest,
    total_payable: selectedItem.total_payable,

    interest_pay: payForm.interestPay,
    principal_pay: payForm.principalPay,
     pay_date: `${payForm.payDate} ${getCurrentDateTime().split(" ")[1]}`,
    pay_method: payForm.payMethod,
    upi_number: payForm.upiNumber,
    remain_interest_amount:selectedItem?.remain_interest_amount,
    remain_loan_amount:selectedItem?.remain_loan_amount
  };

  try {
    const response = await superAdminApis.financeUpdateAPI(payload);

    if (response?.apiStatus?.code === "200") {
      toast.success(response?.apiStatus?.message)
       const modal = document.getElementById("addfinancepay"); 
const modalInstance = window.bootstrap.Modal.getInstance(modal);
modalInstance.hide();
      setPayModal(false);
      handleFinanceList();
    }
  } catch (err) {
    toast.error(err?.apiStatus?.message)
    console.error(err);
  } finally {
    setSubmit(false);
  }
};



const handleView = async (item) => {
  console.log(item);
  
  const res = await superAdminApis.financeGet(item.id);
  setSelectedCustomer(res.result);
};


const getPayMethod = (method) => {
  console.log(method);
  
  switch (method) {
    case "gpay":
      return <img src={gpay} width="54" />;
    case "phonepe":
      return <img src={phonepe} alt="phonepe" width="35" />;
    case "cash":
      return <span>💵 Cash</span>;
    case "account":
      return <span>🏦 Account</span>;
    default:
      return "-";
  }
};

  return (
    <div>
          <div className="d-flex justify-content-between align-items-center mt-3 mb-4">

        {/* Left side (Breadcrumb) */}
        <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={handleBackCustomer}>  {t("dashboard")}</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
             Finance Details
            </li>
          </ol>
        </nav>

   <div className="d-flex gap-3">
   

    <button className="btn add-customer" onClick={handleBackCustomer}>
      <i className="fa fa-arrow-left me-2"></i> Back
    </button>

     <button className="btn add-customer" data-bs-toggle="modal"
      data-bs-target="#addfinance">
      <i className="fa fa-plus me-2"></i> Add Finance
    </button>
  </div>

      </div>

<div className='customer-list-container card'>
     <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-3">
  <h5 className={`heading-with-line  mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
    <i className="bi bi-journal-text me-1"></i>
  Customer Finance List
    <span className="smooth-line"></span>
  </h5>
  </div>
     <div className='table-section' data-aos="fade-up">
 <table className=" table-bordered">
        <thead className="table-light">
      <tr>
        <th>Sl No</th>
        <th>Name</th>
        <th>Date</th>
        <th>Loan Amt</th>
        <th>Interest Rate</th>
        <th>Interest Amt</th>

        <th>Remaining</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>

<tbody>
  {loading ? (
    <tr>
      <td colSpan="10" className="text-center">
        <div className="gold-dots-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </td>
    </tr>
  ) : financeList && financeList.length > 0 ? (
    financeList?.map((item, index) => (
      <tr key={item?.id || index} className="customer-table-td">
        <td>
          {(currentPage - 1) * recordsPerPage + index + 1}
        </td>

        <td>{item?.name}</td>
        <td>{item?.date}</td>
        <td>₹{item?.loan_amount}</td>
        <td>{item?.interest_rate+"%"}</td>

        <td>₹{item?.total_interest}</td>
        <td className="text-danger fw-bold">₹{item.remain_loan_amount||"0"}</td>
        <td>
          <span className={`badge ${item.paid_status === "true" ? "bg-success" : "bg-danger"}`}>
            {item.paid_status=="false"?"Closed":"Active"}
          </span>
        </td>

    <td className="text-center d-flex justify-content-center align-items-center">

  <span className="icon-btn edit tooltip-box"  data-bs-toggle="modal"
  data-bs-target="#addfinance" onClick={() => handleEdit(item)}>
    <i className="fa-solid fa-pen-to-square"></i>
    <span className="tooltip-text">Edit</span>
  </span>

  <span className="icon-btn view tooltip-box"  data-bs-toggle="modal" data-bs-target="#addfinanceview"  onClick={()=>handleView(item)}>
    <i class="fa-solid fa-eye"></i>
    <span className="tooltip-text">View</span>
  </span>

  <span className="icon-btn pay tooltip-box" data-bs-toggle="modal" data-bs-target="#addfinancepay" onClick={() => handlePayClick(item)}>
    <i className="fa-brands fa-amazon-pay"></i>
    <span className="tooltip-text">Pay</span>
  </span>

  <span className="icon-btn delete tooltip-box"  onClick={() => {
                setFinanceDeleteId(item?.id);
                setCustomerName(item?.name);
              }}  data-bs-toggle="modal"
              data-bs-target="#financeDelete">
    <i className="fa-solid fa-trash"></i>
    <span className="tooltip-text">Delete</span>
  </span>

</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" className={`text-center ${lang === "ta" ? "fs-tamil" : ""}`}>
  {t("noRecords")}
</td>
    </tr>
  )}
</tbody>



     {/* <tbody>
    {financeList.map((item) => (
      <tr key={item.id}>
        <td>1</td>
        <td>{item.name}</td>
        <td>{item.date}</td>
        <td>₹{item.amount}</td>
        <td>{item.interestRate}</td>

        <td>₹{item.interest}</td>
        <td className="text-danger fw-bold">₹{item.remaining}</td>
        <td>
          <span className={`badge ${item.status === "Active" ? "bg-success" : "bg-warning"}`}>
            {item.status}
          </span>
        </td>

         <td className="text-center" style={{ width: "10rem" }}>
                  <div className="action-buttons-wrapper">
                    <div className="action-buttons">
                      <Link
                        to={``}
                        className="btn-view view-btn"
                         data-tooltip="View"
                         style={{color:'blue',background:'azure'}}
                           data-bs-toggle="modal" data-bs-target="#addfinanceview"
                        onClick={() => setSelectedCustomer(item)}
                      >
                      <i class="fa-solid fa-eye"></i>
                      </Link>
        
                      <Link
                        to={""}
                        onClick={() => handleEdit(item)}
                        className="btn-view edit-btn"
                        data-tooltip="Edit"

                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </Link>
        
                      <Link
                        to={``}
                         data-bs-toggle="modal" data-bs-target="#addfinancepay" onClick={() => handlePayClick(item)}
                        className="btn-view pay-btn"
                         data-tooltip="Pay"
                      >
                       <i className="fa-brands fa-amazon-pay"></i>
                      </Link>
                    </div>
        
                    <button
                      className="btn-view delete-btn"
                    onClick={() => handleDelete(item.id)}  data-bs-toggle="modal"
              data-bs-target="#financeDelete"
                      // onClick={() => {
                      //   setCustomerDeleteId(customer?.id);
                      //   setCustomerName(customer?.name);
                      // }}
                       data-tooltip="Delete"
                    >
                     <i className="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </td> 



      </tr>
    ))}
  </tbody> */}


  </table>
  </div>
<div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

  {/* LEFT SIDE */}
  <div className="d-flex align-items-center gap-2">
    <select
      className="form-select form-select-sm"
      style={{ width: "80px" }}
      value={recordsPerPage}
      onChange={(e) => setRecordsPerPage(Number(e.target.value))}
    >
    {pageSizes?.map((size) => (
    <option key={size} value={size}>
      {size}
    </option>
  ))}
    </select>

   <span className={lang === "ta" ? "fs-tamil" : ""}>
  {t("showing")} {(currentPage - 1) * recordsPerPage + 1} -{" "}
  {Math.min(currentPage * recordsPerPage, totalRecords)} {t("of")}{" "}
  {totalRecords}
</span>
  </div>

  {/* RIGHT SIDE */}
  <div>
    <CommonPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
    />
  </div>

</div>

</div>


         {/* Add finance modal */}

<div className="modal fade" id="addfinance" tabIndex="-1">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content shadow-lg rounded-3">

      {/* HEADER */}
      <div className="modal-header text-white" style={{ background: "#7FB77E" }}>
        <h6 className="modal-title">Add Finance</h6>
        <button className="btn-close btn-close-white" data-bs-dismiss="modal" onClick={closeClick}></button>
      </div>

      {/* BODY */}
      <div className="modal-body">
        <div className="row border-input-hover">

          {/* NAME */}
          <div className="col-md-4">
            <label>Name</label>
            <input className="form-control" name="name"
              value={form.name} onChange={handleChange} />
          </div>

          <div className="col-md-4">
  <label>Phone Number</label>
  <input
    type="tel"
    className="form-control"
    name="phoneNumber"
    value={form.phoneNumber}
    onChange={handleChange}
    placeholder="10 digit mobile number"
  />
</div>

          {/* DATE */}
          <div className="col-md-4">
            <label>Date</label>
            <input type="date" 
             onClick={(e) => {
        const input = e.currentTarget;
        if (typeof input.showPicker === "function") {
          input.showPicker(); 
        } else {
          input.focus(); 
        }
      }}

            className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange} />
          </div>

          {/* AMOUNT */}
          <div className="col-md-6 mt-2">
            <label>Loan Amount</label>
            <input type="number" className="form-control"
              name="amount"
              value={form.amount}
              onChange={handleChange} />
          </div>

          {/* RATE */}
          <div className="col-md-6 mt-2">
            <label>Interest Rate (%)</label>
            <select className="form-control"
              name="interestRate"
              value={form.interestRate}
              onChange={handleChange}>
              <option value="">Select</option>
              <option value="12">12%</option>
              <option value="13">13%</option>
              <option value="14">14%</option>
              <option value="15">15%</option>
            </select>
          </div>

          {/* DURATION */}
          <div className="col-md-6 mt-2">
            <label>Pay Duration</label>
            <select className="form-control"
              name="payDuration"
              value={form.payDuration}
              onChange={handleChange}>
              <option value="">Select</option>
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
            </select>
          </div>

          {/* INTEREST */}
          <div className="col-md-6 mt-2">
            <label>Total Interest</label>
            <input className="form-control bg-light"
              value={form.intrestamount}
              readOnly />
          </div>

          {/* WEEKLY / EMI */}
          <div className="col-md-6 mt-2">
            <label>One Weekly Interest</label>
            <input className="form-control bg-light"
              value={form.weeklyInterest}
              readOnly />
          </div>

          {/* TOTAL PAYABLE */}
          <div className="col-md-6 mt-2">
            <label>Total Payable</label>
            <input className="form-control bg-light fw-bold text-success"
              value={form.totalPayable}
              readOnly />
          </div>

          {/* PAY METHOD */}
          {/* <div className="col-md-6 mt-2">
            <label>Pay Method</label>
            <select className="form-control"
              name="payMethod"
              value={form.payMethod}
              onChange={handleChange}>
              <option value="">Select</option>
              <option value="gpay">GPay</option>
              <option value="phonepe">PhonePe</option>
              <option value="cash">Cash</option>
              <option value="account">Account</option>
            </select>
          </div> */}

          {/* CONDITIONAL FIELDS */}
          {form.payMethod === "gpay" && (
            <div className="col-md-6 mt-2">
              <label>GPay Number</label>
              <input className="form-control"
                name="gpayNumber"
                value={form.gpayNumber}
                onChange={handleChange} />
            </div>
          )}

          {form.payMethod === "phonepe" && (
            <div className="col-md-6 mt-2">
              <label>PhonePe Number</label>
              <input className="form-control"
                name="phonePeNumber"
                value={form.phonePeNumber}
                onChange={handleChange} />
            </div>
          )}

        </div>
      </div>

      {/* FOOTER */}

{selectedItem?.paid_status=="false"?<div style={{textAlign:'center',padding:'20px',background:"lightgreen",fontWeight:"600"}}>This Finance is fully closed !</div>: <div className="modal-footer justify-content-center">
        <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={closeClick}>
          Cancel
        </button>

        <button className="btn add-customer" onClick={financeCreate}>
          Submit
        </button>
      </div>}

      

    </div>
  </div>
</div>


{/* Pay modal */}

<div className="modal fade" id="addfinancepay" tabIndex="-1">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content shadow-lg rounded-3">

      {/* HEADER */}
      <div className="modal-header text-white" style={{ background: "#7FB77E" }}>
        <h6 className="modal-title">Finance Loan Payment</h6>
        <button
          className="btn-close btn-close-white"
          data-bs-dismiss="modal" onClick={closeClickPay}
          // onClick={() => setPayModal(false)}
        ></button>
      </div>

      {/* BODY */}
      <div className="modal-body border-input-hover">
        <div className="mb-4 p-3 rounded" style={{ background: "#f1f8f5", border: "1px solid #d4edda" }}>
  
  <div className="row text-center">

    {/* REMAINING */}
    <div className="col-6">
      <p className="mb-1 text-muted">Remaining Principal</p>
      <h6 className="fw-bold text-danger">
        {selectedItem?.remain_interest_amount == null
            ?`₹${selectedItem?.loan_amount || 0}`
            :Number(selectedItem?.remain_loan_amount) > 0
            ? selectedItem?.remain_loan_amount
            : selectedItem?.remain_loan_amount || "0"
        }
      </h6>    

  </div>

    {/* PRINCIPAL SUGGEST */}
    {/* <div className="col-4">
      <p className="mb-1 text-muted">Principal Due</p>
      <h6 className="fw-bold text-primary">₹{selectedItem?.remain_interest_amount||"0"} </h6>
    </div> */}

    {/* INTEREST SUGGEST */}
    <div className="col-6">
  <p className="mb-1 text-muted">Remaining Interest Due</p>

  <h6 className="fw-bold text-warning">
    {selectedItem?.remain_interest_amount == null
      ? `₹${selectedItem?.total_interest || 0}`
      : Number(selectedItem?.remain_interest_amount) === 0
      ? <div className='text-success'>Interest Successfully Paid</div>
      : `₹${selectedItem?.remain_interest_amount}`}
  </h6>
</div>

  </div>
</div>
        <div className="row">

          {/* NAME */}
          <div className="col-md-6 mb-2">
            <label>Name</label>
            <input
              className="form-control"
              value={payForm?.name || ""}
              disabled
            />
          </div>

          {/* PRINCIPAL */}
          <div className="col-md-6 mb-2">
            <label>Principal Pay</label>
            <input
              type="number"
              className="form-control"
              value={payForm.principalPay}
              onChange={(e) =>
                setPayForm({ ...payForm, principalPay: e.target.value })
              }
            />
          </div>

          {/* INTEREST */}
         {selectedItem?.interest_status === "false" ? (
  <div className="col-md-6 mb-2" >
    <label>Interest Pay</label>
    <div className="text-success fw-bold form-control" style={{borderColor:'green'}}>
      முழு வட்டி  செலுத்தப்பட்டது
    </div>
  </div>
) : (
  <div className="col-md-6 mb-2">
    <label>Interest Pay</label>
    <input
      type="number"
      className="form-control"
      value={payForm.interestPay}
      onChange={(e) =>
        setPayForm({ ...payForm, interestPay: e.target.value })
      }
    />
  </div>
)}
          {/* PAY DATE */}
          <div className="col-md-6 mb-2">
            <label className='required-star'>Pay Date</label>
            <input
              type="date"
               onClick={(e) => {
        const input = e.currentTarget;
        if (typeof input.showPicker === "function") {
          input.showPicker(); 
        } else {
          input.focus(); 
        }
      }}
              className="form-control"
              value={payForm.payDate}
              onChange={(e) =>
                setPayForm({ ...payForm, payDate: e.target.value })
              }
                style={submit && payForm.payDate.length === 0 ? { borderColor: 'red' } : {}}
            />
            {submit&&payForm.payDate.length===0?<div className='text-danger'>Pay date is required</div>:""}
          </div>

          {/* PAY METHOD */}
          <div className="col-md-6 mb-2">
            <label>Pay Method</label>
            <select
              className="form-control"
              value={payForm.payMethod}
              onChange={(e) =>
                setPayForm({ ...payForm, payMethod: e.target.value })
              }
            >
              <option value="">Select Method</option>
              <option value="gpay">GPay</option>
              <option value="phonepe">PhonePe</option>
              <option value="cash">Cash</option>
              <option value="account">Account</option>
            </select>
          </div>

          {/* CONDITIONAL FIELDS */}
          {payForm.payMethod === "gpay" && (
            <div className="col-md-6 mb-2">
              <label>GPay Number</label>
              <input
                className="form-control"
                value={payForm.gpayNumber}
                maxLength={10}
                onChange={(e) =>
                  setPayForm({ ...payForm, gpayNumber: e.target.value })
                }
              />
            </div>
          )}

          {payForm.payMethod === "phonepe" && (
            <div className="col-md-6 mb-2">
              <label>PhonePe Number</label>
              <input
                className="form-control"
                maxLength={10}
                value={payForm.phonePeNumber}
                onChange={(e) =>
                  setPayForm({ ...payForm, phonePeNumber: e.target.value })
                }
              />
            </div>
          )}

          {payForm.payMethod === "account" && (
            <div className="col-md-6 mb-2">
              <label>Account Number</label>
              <input
                className="form-control"
                value={payForm.accountNumber}
                onChange={(e) =>
                  setPayForm({ ...payForm, accountNumber: e.target.value })
                }
              />
            </div>
          )}

        </div>
      </div>

      {/* FOOTER */}

 {selectedItem?.paid_status=="false"?<div style={{textAlign:'center',padding:'20px',background:"lightgreen",fontWeight:"600"}}>This Finance is fully closed !</div>: <div className="modal-footer justify-content-center">
        <button
          className="btn btn-secondary"
         data-bs-dismiss="modal" onClick={closeClickPay}
        >
          Cancel
        </button>

        <button className="btn add-customer" onClick={handlePay}>
          Submit Payment
        </button>
      </div>}


     

    </div>
  </div>

 
</div>

{/* view moadl */}

<div className="modal fade" id="addfinanceview" tabIndex="-1">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content shadow-lg rounded-3">

      {/* HEADER */}
      <div className="modal-header text-white" style={{ background: "#7FB77E" }}>
        <h6 className="modal-title">Customer Finance View</h6>
        <button
          className="btn-close btn-close-white"
          data-bs-dismiss="modal" onClick={closeClick}
        ></button>
      </div>

      {/* BODY */}
     <div className="modal-body">

  {selectedCustomer && (
    <>
      {/* 🔹 CUSTOMER INFO CARD */}
      <div className="p-3 mb-3 rounded shadow-sm" style={{ background: "#f8fff9" }}>
        <div className="row">

          <div className="col-md-4">
            <b>Name:</b> {selectedCustomer.name}
          </div>

          <div className="col-md-4">
            <b>Phone:</b> {selectedCustomer.phone_no}
          </div>

          <div className="col-md-4">
            <b>Date:</b> {selectedCustomer.date}
          </div>

          <div className="col-md-4 mt-2">
            <b>Amount:</b> ₹{selectedCustomer.loan_amount}
          </div>

          <div className="col-md-4 mt-2">
            <b>Interest:</b> {selectedCustomer.interest_rate}%
          </div>

          <div className="col-md-4 mt-2">
            <b>Status:</b>{" "}
            <span className={`badge ${selectedCustomer.paid_status === "true" ? "bg-success" : "bg-danger"}`}>
              {selectedCustomer.paid_status=='false'?"Closed":"Active"}
            </span>
          </div>

        </div>
      </div>

      {/* 🔹 PAYMENT TABLE */}
      <div className="table-responsive">
        <table className="table table-bordered text-center">
          <thead style={{ background: "#e9f7ef" }}>
            <tr>
              <th>Sl No</th>
              <th>Name</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>Pay</th>
              <th>Pay Time</th>
              <th>Pay Date</th>
            </tr>
          </thead>

         <tbody>
  {selectedCustomer?.payment_history?.length > 0 ? (
    selectedCustomer?.payment_history?.map((item, index) => (
      <tr key={index}>
        <th>{index + 1}</th>

        <td>{selectedCustomer?.name}</td>

        <td>₹{item?.principal_pay}</td>
        <td>₹{item?.interest_pay}</td>
    <td>{getPayMethod(item?.pay_method)}</td>

       <td>
  {
    new Date(item?.pay_date.replace(" ", "T"))
      .toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      })
  }
</td>
<td>{item?.pay_date?.split(" ")[0]}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">No payment history</td>
    </tr>
  )}
</tbody>
        </table>
      </div>
    </>
  )}

</div>

      {/* FOOTER */}
      <div className="modal-footer justify-content-center">
        <button
          className="btn btn-secondary"
         data-bs-dismiss="modal"
        >
          Cancel
        </button>

      
      </div>

    </div>
  </div>

 
</div>

 <div
  className="modal fade"
  id="financeDelete"
  tabIndex="-1"
  aria-labelledby="deleteModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">

      <div className="modal-header text-white"  style={{background:"#7FB77E"}}>
        <h6 className={`modal-title ${lang === "ta" ? "fs-tamil" : ""}`} id="deleteModalLabel">
          {t("confirmDelete")}
        </h6>

        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          id="closedeleteModal"
        ></button>
      </div>

      <div className={`modal-body text-center ${lang === "ta" ? "fs-tamil" : ""}`}>
        Are you sure you want to delete this customer {customerName} ?
        {/* <span className="delete-customer-name">{customerName}</span> ? */}
      </div>

      <div className="modal-footer justify-content-center">

        <button
          type="button"
          className={`btn add-customer ${lang === "ta" ? "fs-tamil" : ""}`}
          onClick={handleDeleteFinance}
        >
          {t("yesDelete")}
        </button>

        <button
          type="button"
          className={`btn btn-secondary ${lang === "ta" ? "fs-tamil" : ""}`}
          data-bs-dismiss="modal"
        >
          {t("cancel")}
        </button>

      </div>

    </div>
  </div>
</div>

    </div>
  )
}

export default AddFinance
